import { Grid, Modal, TextField, Paper, FormControlLabel, Switch, Typography, Button, CircularProgress } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from 'components/Theme';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { createProductCampaign, editProductCampaign } from 'store/Orbita/Product/actions';

import Coaffiliates from './components/Coaffiliates';

import type IUser from 'interfaces/IUser';
import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  campaign?: any;
  product: any;
  handleClose: any;
  onChangeTab?: any;
  producer?: any;
  tabActive?: any;
  updateListCampaigns?: any;
  editProductCampaign: any;
  createProductCampaign: any;
  open: any;
  user: IUser;
}

class CampaignForm extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isReadyToSave: true,
      isEditing: false,
      campaign: {
        active: true,
        title: '',
        product_id: 0,
        url: '',
        public: false,
        coaffiliates: [],
      },
    };
  }

  componentDidMount() {
    if (this.props.campaign) {
      const campaign = JSON.parse(JSON.stringify(this.props.campaign));
      campaign.product_id = this.props.product.id;
      this.setState({ isEditing: true, campaign });
    } else {
      const user = this.props.user;
      const campaign = this.state.campaign;
      campaign.product_id = this.props.product.id;
      campaign.coaffiliates.push({
        customer_id: user.id,
        percent: 100,
        name: user.full_name,
        email: user.email,
      });
      this.setState({ isEditing: false, campaign });
    }
  }

  handleChange = (field: any, e: any) => {
    const campaign = this.state.campaign;
    campaign[field] = e.target.value;
    this.setState({ campaign });
  };

  handleChangeCheck = (field: any, e: any) => {
    const campaign = this.state.campaign;
    campaign[field] = e.target.checked;
    this.setState({ campaign });
  };

  handleChangeCoAffiliates = (coaffiliates: any) => {
    const newCampaign = this.state.campaign;
    newCampaign.coaffiliates = coaffiliates;
    this.setState({ campaign: newCampaign });
  };

  setReadyToSave = (isReady: boolean) => {
    this.setState({ isReadyToSave: isReady });
  };

  handleSubmit = () => {
    let { campaign } = this.state;

    if (campaign.url === '') {
      toast.error('A URL não pode estar vazia');
      return;
    }

    if (campaign.title === '') {
      toast.error('A Nome da campanha não pode estar vazia');
      return;
    }

    //produtor não valida coafiliado
    if (!this.props.product.is_producer) {
      if (campaign.coaffiliates.filter((item: any) => item.percent === 0).length > 0) {
        toast.error('Nenhum coafiliado deve ter valor zero');
        return;
      }

      if (campaign.coaffiliates.filter((item: any) => item.customer_id === 0).length > 0) {
        toast.error('Adicione coafiliados válidos');
        return;
      }

      if (campaign.coaffiliates.reduce((acc: number, item: any) => acc + Number.parseFloat(item.percent), 0) !== 100) {
        toast.error('A soma das porcentagens de coafiliados deve ser 100');
        return;
      }
    } else {
      delete campaign.coaffiliates;
    }

    campaign = { ...campaign, url: campaign.url.trim() };

    if (this.state.isEditing) {
      (async () => {
        try {
          delete campaign.status;
          await this.props.dispatch(editProductCampaign(this.props.product.id, campaign.id, campaign));
          toast.success('Campanha alterada com sucesso!');
          this.props.handleClose(true);
          updateList();
        } catch (error) {
          toast.error(error);
        }
      })();
    } else {
      (async () => {
        try {
          await this.props.dispatch(createProductCampaign(this.props.product.id, campaign));
          toast.success('Campanha criada com sucesso!');
          this.props.handleClose();
          updateList();
        } catch (error) {
          toast.error(error);
        }
      })();
    }

    const updateList = () => {
      if (this.props.tabActive === 1) {
        this.props.updateListCampaigns(this.props.product.id, 'producer');
      } else {
        this.props.updateListCampaigns(this.props.product.id, 'my-links');
      }
    };
  };

  render() {
    const { editProductCampaign, createProductCampaign } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <Modal open={this.props.open} onClose={this.props.handleClose}>
          <Paper
            elevation={10}
            style={{
              width: '780px',
              maxWidth: '100%',
              height: 'auto',
              top: '50%',
              left: '50%',
              position: 'absolute',
              transform: 'translate(-50%,-50%)',
              padding: '1.5rem',
            }}
          >
            <Typography variant='h6' style={{ color: '#192542' }}>
              {this.state.isEditing ? 'Edição de campanha' : 'Cadastro de campanha'}
            </Typography>
            <div className='m16' />
            <div>{this.state.isEditing ? 'Edite seu funil/campanha' : 'Crie seu funil/campanha'}</div>
            <div className='m16' />
            <Grid container>
              <Grid item md={2} xs={12}>
                <FormControlLabel
                  control={
                    <Switch color='secondary' checked={this.state.campaign.active} onChange={(e: any) => this.handleChangeCheck('active', e)} />
                  }
                  label={this.state.campaign.active ? 'Ativo' : 'Inativo'}
                />
              </Grid>
              <Grid item md={10} xs={12}>
                <TextField
                  helperText='Ex: Campanha de lançamento'
                  label='Nome da Campanha'
                  fullWidth
                  value={this.state.campaign.title}
                  onChange={(e: any) => this.handleChange('title', e)}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <TextField
                  helperText='Ex: https://google.com'
                  label='URL de destino'
                  fullWidth
                  value={this.state.campaign.url}
                  onChange={(e: any) => this.handleChange('url', e)}
                />
              </Grid>
              {!this.props.product.is_producer && (
                <Fragment>
                  <div className='m16' />
                  <div>Coafiliados</div>
                  <div className='m16' />
                  {/* se não for produtor mostrar form de coafiliado */}
                  <Grid>
                    <Coaffiliates
                      coaffiliates={this.state.campaign.coaffiliates}
                      handleChangeCoAffiliates={this.handleChangeCoAffiliates}
                      public={this.state.campaign.public}
                      onChangeCheck={this.handleChangeCheck}
                      setReadyToSave={this.setReadyToSave}
                    />
                  </Grid>
                </Fragment>
              )}
            </Grid>
            <div className='m16' />
            <Grid container justify='flex-end'>
              <Button
                color='default'
                disabled={(editProductCampaign && editProductCampaign.isFetching) || (createProductCampaign && createProductCampaign.isFetching)}
                onClick={this.props.handleClose}
              >
                Fechar
              </Button>
              <Button
                color='secondary'
                variant='contained'
                disabled={
                  (editProductCampaign && editProductCampaign.isFetching) ||
                  (createProductCampaign && createProductCampaign.isFetching) ||
                  !this.state.isReadyToSave
                }
                onClick={this.handleSubmit}
              >
                Salvar
                {((editProductCampaign && editProductCampaign.isFetching) || (createProductCampaign && createProductCampaign.isFetching)) && (
                  <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />
                )}
              </Button>
            </Grid>
          </Paper>
        </Modal>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    editProductCampaign: state.orbita.Product.editProductCampaign,
    createProductCampaign: state.orbita.Product.createProductCampaign,
    user: state.orbita.User.originalUser,
  };
}

export default connect(mapStateToProps)(CampaignForm);
